import script from "./AddProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductModal.vue?vue&type=script&setup=true&lang=js"

import "./AddProductModal.vue?vue&type=style&index=0&id=4172c8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4172c8ee"]])

export default __exports__